import { Input } from "antd";
import { SearchProps } from "antd/es/input";
import React, { useContext } from "react";
import DataContext from "../../context/DataContext";

const { Search } = Input;

export const SearchInput = () => {
  const { handleSearch } = useContext(DataContext);
  const onSearch: SearchProps["onSearch"] = (value) => handleSearch(value);

  return (
    <Search
      placeholder="Search"
      allowClear
      enterButton="Search"
      size="middle"
      onSearch={onSearch}
    />
  );
};
